const account = {
  state: {
    status: ''
  },

  mutations: {
    SET_STATUS: (state, value) => {
      window.localStorage.setItem('s', value);
    },
    GET_STATUS: (state) => {
      state.status = window.localStorage.getItem('s');
    },
    REMOVE_STATUS: (state) => {
      window.localStorage.removeItem('s');
    }
  },

  actions: {
    
  }
}

export default account



// WEBPACK FOOTER //
// ./src/store/modules/account.js